<template>
    <div>
        <el-dialog title="详情信息" :visible.sync="dialogVisible" width="1200px" @close="handleClose" append-to-body custom-class="detail-info-dialog">
            <div class="header_title">基本信息</div>
            <el-form ref="formRef" :model="form" label-width="155px" class="shouliao_content">
                <el-row :gutter="32">
                    <el-col :span="12">
                        <el-form-item label="车型" prop="ORMTB493CA02">
                            <el-select v-model="form.ORMTB493CA02" placeholder="请选择车型" disabled>
                                <el-option v-for="(item, index) in vehicleModelList" :key="index" :label="item"
                                    :value="item"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="厂家" prop="ORMTB493CA03">
                            <el-select v-model="form.ORMTB493CA03" placeholder="请选择厂家" filterable disabled>
                                <el-option v-for="(item, index) in manuFacturerList" :key="index"
                                    :label="item.SETTB99CA00" :value="item.SETTB99ID"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="32">
                    <el-col :span="12">
                        <el-form-item label="扣款账户" prop="ORMTBSL410ID">
                            <el-select v-model="form.ORMTBSL410ID" placeholder="请选择代发运单账户" filterable disabled>
                                <el-option v-for="(item, index) in accountList" :key="index" :label="item.ZHNAME"
                                    :value="item.ZHID"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="物料类型" prop="ORMTB493CA05">
                            <el-select v-model="form.ORMTB493CA05" placeholder="请选择物料类型" disabled>
                                <el-option v-for="item in materialList" :key="item.settb109ID"
                                    :label="item.settb109CA00" :value="item.settb109ID"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="32">
                    <el-col :span="12">
                        <el-form-item label="卸货地" prop="ORMTB493CA20">
                            <el-input v-if="form.ORMTB493CA20" v-model="form.ORMTB493CA20" disabled></el-input>
                            <!-- <el-button type="primary" @click="handleLocation">地图定位</el-button> -->
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="详细地址" prop="ORMTB493CA21">
                            <el-input v-model="form.ORMTB493CA21" placeholder="请选择卸货地" disabled></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="32">
                    <!-- <el-col :span="12">
                        <el-form-item label="物料价格" prop="materialPrice">
                            <el-input v-model="form.materialPrice" placeholder="请输入物料价格" disabled></el-input>
                        </el-form-item>
                    </el-col> -->
                    <el-col :span="12" class="content_box">
                        <div class="content_box_item_1">
                            <el-form-item label="到货总价" prop="ORMTB493CA07" class="inclusiveType_box">
                                <el-input v-model="form.ORMTB493CA07" placeholder="请输入到货总价" disabled></el-input>
                                <div class="inclusiveType_btn">
                                    <span :class="{ 'activeBlue': form.ORMTB493CA70 === item.value }"
                                        v-for="(item, index) in inclusiveType" :key="index">{{ item.label }}</span>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="content_box_item_2">
                            <el-form-item v-if="form.ORMTB493CA70 == 0" label="发单运费价" prop="ORMTB493CA73" class="inclusiveType_box content_box_item_label">
                                <el-input v-model="form.ORMTB493CA73" placeholder="请输入发单运费价" disabled></el-input>
                                <div class="inclusiveType_btn unit_btn">元</div>
                            </el-form-item>
                        </div>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="运费价格" prop="ORMTB493CA09" class="inclusiveType_bo">
                            <el-input v-model="form.ORMTB493CA09" placeholder="请输入运费价格" disabled></el-input>
                            <div class="inclusiveType_btn unit_btn">元</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="32">
                    <el-col :span="12">
                        <el-form-item label="超时取消时间(小时)" prop="ORMTB493CA27">
                            <el-input v-model="form.ORMTB493CA27" placeholder="请输入超时取消时间(小时)" disabled></el-input>
                            <div class="inclusiveType_btn unit_btn">小时</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="吨数" prop="ORMTB493CA08">
                            <el-input v-model="form.ORMTB493CA08" placeholder="请输入吨数" disabled></el-input>
                            <div class="inclusiveType_btn unit_btn">吨</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="32">
                    <el-col :span="12">
                        <el-form-item label="结算运费甩零" prop="ORMTB493CA36">
                            <el-select v-model="form.ORMTB493CA36" placeholder="请选择" disabled>
                                <el-option v-for="(item, index) in shippingArray" :key="index" :label="item.title"
                                    :value="item.type"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="亏吨范围(吨)" prop="ORMTB493CA25">
                            <el-input v-model="form.ORMTB493CA25" placeholder="请输入亏吨范围(吨)" disabled></el-input>
                            <div class="inclusiveType_btn unit_btn">吨</div>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="32">
                    <el-col :span="12">
                        <el-form-item label="运费结算方式" prop="ORMTB493CA43">
                            <el-select v-model="form.ORMTB493CA43" placeholder="请选择运费结算方式" disabled>
                                <el-option v-for="(item, index) in feeArray" :key="index" :label="item.title"
                                    :value="item.type"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="确认净重" prop="ORMTB493CA35">
                            <el-select v-model="form.ORMTB493CA35" placeholder="请选择" disabled>
                                <el-option v-for="(item, index) in dunArray" :key="index" :label="item.title"
                                    :value="item.type"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="32">
                    <el-col :span="12">
                        <el-form-item label="配送费" prop="ORMTB493CA48">
                            <el-input v-model="form.ORMTB493CA48" placeholder="请输入配送费" disabled></el-input>
                            <div class="inclusiveType_btn unit_btn">元</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="卸货时间" prop="ORMTB493CA37">
                            <el-date-picker v-model="form.ORMTB493CA37" type="datetimerange" range-separator="至"
                                start-placeholder="开始日期" end-placeholder="结束日期" align="right" format="yyyy-MM-dd HH:mm"
                                value-format="yyyy-MM-dd HH:mm" disabled>
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="32">
                    <el-col :span="12">
                        <el-form-item label="管理费" prop="ORMTB493CA34">
                            <el-input v-model="form.ORMTB493CA34" placeholder="请输入管理费" disabled></el-input>
                            <div class="inclusiveType_btn unit_btn">%</div>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="接单是否审核" prop="ORMTB493CA44">
                            <el-select v-model="form.ORMTB493CA44" placeholder="请选择接单是否审核" disabled>
                                <el-option v-for="(item, index) in examineArray" :key="index" :label="item.title"
                                    :value="item.type"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="32">
                    <el-col :span="12">
                        <el-form-item label="公开运单" prop="ORMTB493CA31">
                            <el-radio-group v-model="form.ORMTB493CA31">
                                <el-radio :label="2" disabled>是</el-radio>
                                <el-radio :label="1" disabled>否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="隐藏运费接单价" prop="ORMTB493CA38">
                            <el-radio-group v-model="form.ORMTB493CA38">
                                <el-radio :label="1" disabled>是</el-radio>
                                <el-radio :label="0" disabled>否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="32">
                    <el-col :span="12">
                        <el-form-item label="指定车辆" prop="ORMTB493CA30">
                            <el-radio-group v-model="form.ORMTB493CA30">
                                <el-radio :label="1" disabled>是</el-radio>
                                <el-radio :label="2" disabled>否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="冻结接单人物料金额" prop="ORMTB493CA32">
                            <el-radio-group v-model="form.ORMTB493CA32">
                                <el-radio :label="1" disabled>是</el-radio>
                                <el-radio :label="0" disabled>否</el-radio>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>
                <template v-if="form.ORMTB493CA30 == 1">
                    <!-- <el-row :gutter="32">
                        <el-col :span="24">
                            <div class="add_btn el-form-item" @click="addVehicle">添加车辆</div>
                        </el-col>
                    </el-row> -->
                    <el-row :gutter="32">
                        <el-col :span="24" v-if="selectedList.length > 0">
                            <!-- <div class="el-form-item" style="font-weight: 700;font-size: 14px;">已选中车辆</div> -->
                            <div class="car_list">
                                <el-tag class="car_list_item" v-for="item in selectedList" :key="item" type="info">
                                    {{ item }}
                                </el-tag>
                            </div>
                        </el-col>
                        <!-- <el-col :span="24">
                            <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
                                @change="handleCheckAllChange">全选</el-checkbox>
                        </el-col> -->
                        <!-- <el-checkbox-group v-model="checkedCar">
                            <el-col :span="12" v-for="(item, index) in carList" :key="index">
                                <div class="checkbox_item">
                                    <el-checkbox :label="item.SETTB402CA00" :key="item.SETTB402CA00" disabled>{{
                                        item.SETTB402CA00 }}</el-checkbox>
                                </div>
                            </el-col>
                        </el-checkbox-group> -->
                    </el-row>
                </template>
                <el-row>
                    <el-col :span="24" style="text-align: right;">
                        <el-button @click="dialogVisible = false">取消</el-button>
                        <el-button type="primary" @click="dialogVisible = false">确定</el-button>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "AuditInfoDialog",
    props: {
        visible: {
            type: Boolean,
            default: false,
        },
        id: {
            type: String,
            default: '',
        }
    },
    data() {
        return {
            selectedList: [],
            dialogVisible: this.visible,
            checkAll: false,
            checkedCar: [],
            isIndeterminate: true,
            addShow: false,
            mapShow: false,
            vehicleModelList: ['13米', '7米6', '9.6米'],//车型列表
            manuFacturerList: [],//厂家列表
            materialList: [],//物料列表
            accountList: [],//账户列表
            carList: [],//车辆列表
            inclusiveType: [
                { label: '不含税', value: 0 },
                { label: '含税', value: 1 },
            ],
            form: {
                ORMTB493CA02: '13米',
                SETTB99CA00: '',
                ORMTB493CA70: 1,//是否含税,默认含税
                ORMTBSL410ID: '',
                ORMTB493CA20: '',
                ORMTB493CA21: '',
                ORMTB493CA05: '',
                // materialPrice: '',
                ORMTB493CA07: '',
                ORMTB493CA09: '',
                // costPrice: 10,
                ORMTB493CA27: 24,
                ORMTB493CA08: '',
                ORMTB493CA36: -1,
                ORMTB493CA25: '',
                ORMTB493CA43: 1,
                ORMTB493CA35: 1,
                ORMTB493CA37: '',
                ORMTB493CA48: '',
                ORMTB493CA34: 0,
                ORMTB493CA44: 0,
                ORMTB493CA38: 0,
                ORMTB493CA31: 2,
                ORMTB493CA30: 2,
                ORMTB493CA32: 0,
                ORMTB493CA22: '',//经度
                ORMTB493CA23: '',//维度
                ormtb461List: [],//选中车牌
                ORMTB493CA73: ''
            },
            dunArray: [
                {
                    type: 1,
                    title: '保留一位小数',
                },
                {
                    type: 2,
                    title: '保留两位小数',
                },
                {
                    type: 3,
                    title: '保留三位小数',
                },
            ],
            shippingArray: [
                {
                    type: -1,
                    title: '甩块',
                },
                {
                    type: 0,
                    title: '甩毛',
                },
                {
                    type: 1,
                    title: '甩分',
                },
                {
                    type: 2,
                    title: '不甩零',
                },
            ],
            feeArray: [
                {
                    type: 0,
                    title: '线上结算',
                },
                {
                    type: 1,
                    title: '线下结算',
                },
            ],
            examineArray: [
                {
                    type: 0,
                    title: '不审核',
                },
                {
                    type: 1,
                    title: '审核',
                },
            ],
        };
    },
    watch: {
        visible(newVal) {
            this.dialogVisible = newVal;
            if (newVal) {
                this.getManuFacturerList();
                this.getAccountList();
                this.getCarList();
                this.getDetailInfo();
            }
        },
        'form.ORMTB493CA03': {
            handler(newVal, oldVal) {
                this.getMaterialList(newVal);
            },
            deep: false,
            immediate: false
        }
    },
    methods: {
        getList(value) {
            this.getMaterialList(value);
        },
        getDetailInfo() {
            this.axios.post('/orm/ormtb493/detailOrmtb493Admin', { ORMTB493ID: this.id }).then(res => {
                if (res.data.code == 200) {
                    this.form = res.data.data.ormtb493;
                    this.form.ORMTB493CA38 = Number(this.form.ORMTB493CA38);
                    this.form.ORMTB493CA36 = Number(this.form.ORMTB493CA36);
                    this.form.ORMTB493CA35 = Number(this.form.ORMTB493CA35);
                    this.form.ORMTB493CA34 = (this.form.ORMTB493CA34) * 100;
                    this.form.ORMTB493CA37 = this.convertApiDateToRange(this.form.ORMTB493CA37);
                    this.selectedList = res.data.data.ormtb461s.map(item => item.carPlate);
                    // this.checkedCar = res.data.data.ormtb461s.length > 0 ? res.data.data.ormtb461s.map(item => item.carPlate) : [];
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        convertApiDateToRange(apiDateString) {
            if (!apiDateString || !apiDateString.includes('~')) {
                return [];
            }
            return apiDateString.split('~');
        },
        //车辆列表
        getCarList() {
            this.axios.post('/set/settb402/selectSettb402BySign', { SETTB402CA00: '' }).then(res => {
                if (res.data.code == 200) {
                    this.carList = res.data.data;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        //获取扣款账户
        getAccountList() {
            this.axios.post('/set/settb402/selectYfAccount', {}).then(res => {
                if (res.data.code == 200) {
                    this.accountList = res.data.data;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        //获取厂家列表
        getManuFacturerList() {
            this.axios.post('/set/settb402/settb99SelectPageList', {}).then(res => {
                if (res.data.code == 200) {
                    this.manuFacturerList = res.data.data;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        //获取物料类型
        getMaterialList(value) {
            this.axios.post('/set/settb402/ormtb440SelectAllSettb109', { SETTB99ID: value }).then(res => {
                if (res.data.code == 200) {
                    this.materialList = res.data.data;
                } else {
                    this.$message({
                        message: res.data.message,
                        type: 'error',
                    })
                }
            })
        },
        handleClose() {
            this.dialogVisible = false;
            this.$emit('update:visible', false);
        },
    }
};
</script>
<style scoped>
.header_title {
    font-size: 18px;
    color: #333;
    border-top: 1px solid #D9D9D9;
    padding: 20px 0 20px;
    box-sizing: border-box;
}

/deep/.el-dialog {
    margin-top: 7vh !important;
}

/deep/.el-dialog__body {
    padding-top: 0;
}

/deep/.el-form-item__label {
    width: 155px !important;
    padding: 0 !important;
    text-align: left !important;
    font-size: 16px !important;
}

.addCarDialog /deep/.el-form-item__label {
    width: 127px !important;
}

/deep/.el-select {
    width: 100% !important;
}

.shouliao_content {
    height: 70vh;
    overflow-y: auto;
    overflow: -moz-scrollbars-none;
    /* 旧版 Firefox */
    scrollbar-width: none;
    /* 新版 Firefox */
    -ms-overflow-style: none;
    /* IE and Edge */
}

.shouliao_content .el-row {
    margin-bottom: 12px;
}

.shouliao_content .el-row:last-child {
    margin-bottom: 0;
}

.add_btn {
    width: 80px;
    height: 32px;
    line-height: 32px;
    text-align: center;
    border-radius: 12px;
    background: #199FFF;
    font-size: 14px;
    color: #fff;
    cursor: pointer;
}

/deep/.el-checkbox__inner {
    width: 24px;
    height: 24px;
    border-radius: 4px;
}

/deep/.el-checkbox__inner::after {
    height: 12px;
    left: 9px;
    top: 3px;
    width: 4px;
}

/deep/.el-checkbox__inner::before {
    top: 10px !important;
}

/deep/.el-checkbox__label {
    font-size: 19px;
    vertical-align: middle;
}

.checkbox_item {
    width: 445px;
    height: 58px;
    line-height: 58px;
    background: #F5F7FA;
    border-radius: 6px;
    margin: 12px 0;
    padding-left: 20px;
    box-sizing: border-box;
}

.inclusiveType_box {
    position: relative;
}

.inclusiveType_btn {
    position: absolute;
    top: 0;
    right: 0;
    height: 38px;
    line-height: 38px;
    font-size: 12px;
    color: #9E9E9E;
    cursor: pointer;
}

.inclusiveType_btn>span {
    margin-right: 14px;
}

.activeBlue {
    color: #199FFF;
}

.unit_btn {
    margin-right: 12px;
}

.car_list {
    margin-bottom: 20px;
}

.car_list::-webkit-scrollbar {
    width: 0;
    height: 0;
}
.content_box {
    width: 50%;
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    /* 可选，设置元素间距 */
}
.car_list_item {
    margin-bottom: 10px;
    margin-left: 0 !important;
    margin-right: 10px;
}
.content_box_item_1 {
    width: 312px;
}
.content_box_item_2 {
    flex:1;
}
/deep/.content_box_item_label .el-form-item__label {
    width: 90px !important;
}
/deep/.content_box_item_label .el-form-item__content{
    margin-left: 90px!important;
}
</style>
<style>
.detail-info-dialog {
	border-radius: var(--fszs-radius-lg);
	box-shadow: var(--fszs-shadow-lg);
	overflow: hidden;
}

.detail-info-dialog .el-dialog__header {
	height: auto;
	line-height: normal;
	padding: 18px 54px 15px 24px;
	vertical-align: middle;
	background: linear-gradient(90deg, rgba(23, 139, 255, 0.10) 0%, rgba(23, 139, 255, 0) 42%), linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
	border-bottom: 1px solid var(--fszs-border-soft);
	color: var(--fszs-text-strong);
}

.detail-info-dialog .el-dialog__title {
	font-size: 18px;
	font-weight: 700;
	color: #102033 !important;
}

.detail-info-dialog .el-dialog__headerbtn {
	top: 12px;
	right: 16px;
	border-radius: 50%;
}

.detail-info-dialog .el-dialog__headerbtn .el-dialog__close {
	vertical-align: middle;
	font-size: 18px;
	color: #55708b !important;
}
</style>
